import { normalize, schema } from 'normalizr';

export const getNormalizedStages = (stagesData) => {
    if (!stagesData.length) {
        return {
            entities: {
                stages: {},
                positions: {},
            },
            result: [],
        };
    }

    const arrayPosition = stagesData.map((stage) => {
        const positions = Object.values(stage.positions || stage.positions);
        return { ...stage, positions };
    });

    const position = new schema.Entity(
        'positions',
        {},
        {
            idAttribute: 'guid',
        }
    );
    const stage = new schema.Entity('stages', {
        positions: [position],
    });

    const normalizedData = normalize(arrayPosition, [stage]);

    return normalizedData;
};

export const getNormalizedCharters = (chartersData) => {
    const arrayChildren = [];

    if (!chartersData.length) {
        return {
            entities: {
                charters: null,
                children: null,
            },
        };
    }

    for (const charter of chartersData) {
        const children = Object.values(charter.children);
        const updatedCharter = { ...charter, children };
        arrayChildren.push(updatedCharter);
    }

    const child = new schema.Entity('children', {}, { idAttribute: 'guid' });
    const charter = new schema.Entity(
        'charters',
        {
            children: [child],
        },
        {
            idAttribute: 'guid',
        }
    );

    const normalizedData = normalize(arrayChildren, [charter]);

    return normalizedData;
};

export const getNormalizedStagesA = (stagesData) => {
    const position = new schema.Entity(
        'positions',
        {},
        {
            idAttribute: 'guid',
        }
    );
    const stage = new schema.Entity('stages', {
        positions: [position],
    });

    const normalizedData = normalize(stagesData, [stage]);

    return normalizedData;
};

export const getNormalizedChartersA = (chartersData) => {
    const child = new schema.Entity('children', {}, { idAttribute: 'guid' });
    const charter = new schema.Entity(
        'charters',
        {
            children: [child],
        },
        {
            idAttribute: 'guid',
        }
    );

    const normalizedData = normalize(chartersData, [charter]);

    return normalizedData;
};
